import React from 'react';

const Logo = props => (
    <svg width={234.532} height={20.475} viewBox="0 0 62.053 5.417" {...props}>
        <g
            aria-label="~Donor Management System~"
            style={{
                lineHeight: 1.25,
            }}
            fontWeight={400}
            fontSize={7.056}
            fontFamily="Permanent Marker"
            letterSpacing={0}
            wordSpacing={0}
            strokeWidth={0.265}
            fill="#fff"
        >
        </g>
    </svg>
);

export default Logo;
